// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactDnd$LiteracyplanetTupperware from "./ReactDnd.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";
import * as PilotClozeChoiceProvider$LiteracyplanetTupperware from "../v3/PilotClozeChoiceProvider.res.mjs";

function V2ClozeChoiceProvider(props) {
  var children = props.children;
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  if (Curry._1(hasFlag, {
          NAME: "Unleash",
          VAL: "temp_hasPilotLayout"
        })) {
    return React.createElement(PilotClozeChoiceProvider$LiteracyplanetTupperware.make, {
                questionIndex: props.questionIndex,
                children: children
              });
  } else {
    return React.createElement(ReactDnd$LiteracyplanetTupperware.Provider.make, {
                children: children
              });
  }
}

var make = V2ClozeChoiceProvider;

var $$default = V2ClozeChoiceProvider;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
